import React, { Component } from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon, MDBFormInline  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip, Radio,Popover  } from 'antd';
import Swal from 'sweetalert2'
import { URL,api } from '../api';
import ban from '../img/math.png'
import fx from '../img/fx.png'
import { Base64 } from 'js-base64';

export default class Modalregister extends Component {
    constructor(props) {
        super(props);
                this.state = {
                modal: false,

                send_id :'1', //ผู้ลงทะเบียน
                send_type : '', //ประเภท
                name_present : '', //ผู้นำเสนอ
                name_presentcertificate:'',
                name_article : '', //ชื่อบทความ
                major_precent : 'คณิตศาสตร์', //สาขาที่นำเสนอ
               

                send_uploadeword12 : null,
                send_uploadepdf12 : null,
                URLdrive:'',
                send_date1 : '', //  วันที่ส่ง
                send_status : '', //สถานะ ชำระเงิน
                stapat : '0',   //สถานะส่ง

                iduser:'',
                radio: "",
                articletype:[],

                loading:false,

//////////////////////////////////////
                iduser : '',
                nameuser : '',
                send_uploadeword1 : null,
                send_uploadeword2 : null,
                send_uploadeword3 : null,
                send_uploadeword4 : null,
                send_uploadepdf1 : null,
                send_uploadepdf2 : null,
                send_uploadepdf3 : null,
                send_uploadepdf4 : null,
                dateadd :'',
                status :'',

                typelevel:'',
                name_rob:'',
            
                }

                this.handleChange1 = this.handleChange1.bind(this);
                this.handleChangew2 = this.handleChangew2.bind(this);
                this.handleChangew3 = this.handleChangew3.bind(this);
                this.handleChangew4 = this.handleChangew4.bind(this);
                this.handleChange2 = this.handleChange2.bind(this);
                this.handleChangep2 = this.handleChangep2.bind(this);
                this.handleChangep3 = this.handleChangep3.bind(this);
                this.handleChangep4 = this.handleChangep4.bind(this);

             //   this.handleChange3 = this.handleChange3.bind(this);
             //   this.handleChange4 = this.handleChange4.bind(this);
                this.handleSubmit = this.handleSubmit.bind(this);


                this.handleChangetype = this.handleChangetype.bind(this);
                this.toggle = this.toggle.bind(this);
                this.handleChangemajor = this.handleChangemajor.bind(this);
                this.handleChangenamepresent = this.handleChangenamepresent.bind(this);
                this.handleChangesend_name = this.handleChangesend_name.bind(this);
                this.onClickradio = this.onClickradio.bind(this);
                this.gettype = this.gettype.bind(this);
                this.handleChangenamepresentcer = this.handleChangenamepresentcer.bind(this);
                this.handleChangeURLdrive = this.handleChangeURLdrive.bind(this);
                this.linenotify = this.linenotify.bind(this);
                this.viwecertificase = this.viwecertificase.bind(this);
                this.onChange = this.onChange.bind(this);
                this.getrob = this.getrob.bind(this);
}


onChange = e => {
  console.log('radio checked', e.target.value);
  this.setState({
    radio: e.target.value,
  });
};


viwecertificase = () => {

  // var datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
  // datafrm.append("name_article", this.state.name_article);
  // datafrm.append("name_presentcertificate", this.state.name_presentcertificate);
  // Axios.post('https://scitech.kpru.ac.th/csrm2025/system/conferencekpru/certificaseshow.php', datafrm)
  //     .then((res) => {
    
  //        // this.props.history.push('/Customers') //เมื่อบันทึกเสร็จจะทำการให้เปลี่ยนไปที่ path Customers
  //     })
  //     .catch((err) => { 
  //      // alert("ไม่สำเร็จ " + err)
  //      })
 // var decodedStringBtoA = 'Hello World!+++';
  //const dd = 'name_article='+this.state.name_article+'&name_presentcertificate='+this.state.name_presentcertificate;
 // const encoded = btoa(this.state.name_article);
      // console.log(encoded);

      const dd = Base64.encode(this.state.name_article); 

  setTimeout(() => {
    window.open('https://scitech.kpru.ac.th/csrm2025/system/conferencekpru/certificaseshow.php?name_article='+dd+'&name_presentcertificate='+this.state.name_presentcertificate, '_blank');
   // window.open('https://scitech.kpru.ac.th/csrm2025/system/conferencekpru/certificaseshow.php?'+encoded, '_blank');
  }, 0);
  

}





linenotify = () => {


  const presentype_id =  this.state.articletype.filter((word) => word.presentype_id === this.state.send_type);
      var datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("presentype_name", presentype_id[0].presentype_name);
 
      api.post('registercon/linenotifyaddarticle', datafrm)
          .then((res) => {
             // this.props.history.push('/Customers') //เมื่อบันทึกเสร็จจะทำการให้เปลี่ยนไปที่ path Customers
          })
          .catch((err) => { alert("ไม่สำเร็จ " + err) })
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
   this.setState({ nameuser:this.props.nameuser})
    this.setState({ iduser:this.props.iduser})
 // this.props.selectatf();
 this.gettype();
 this.getrob();
 if (localStorage.getItem('register_typemamber') === '1' || localStorage.getItem('register_typemamber') === '2') {
  this.setState({ send_status: '2'})
 }
}


onClickradio = (nr) => () => {
  this.setState({
    radio: nr,
  });

};




 componentDidMount() {
       const { iduser } = this.props.iduser
        const { nameuser } = this.props.nameuser
       console.log(this.props.nameuser);
       this.setState({ iduser:iduser})
       this.setState({ nameuser:nameuser})
    //   setTimeout(() => {
    //     //ภายใน
    //      Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
    //     .then(res => {
    //       console.log(res);
    //     //  this.setState({ bankname: res.data, loading: false })
    //       this.setState({ Expert: res.data})
    //     }) 
    //   }, 0);
  }

  gettype() {
    setTimeout(() => {
           
      api.get('registercon/selecttpresentationtype')
       .then(res => {
         console.log(res);
       //  this.setState({ bankname: res.data, loading: false })
         this.setState({ articletype: res.data})
       }) 
     }, 0);
 }


    getrob() {
         setTimeout(() => {
                
           api.get('registercon/Selectrobpsf')
            .then(res => {
              console.log(res);
            //  this.setState({ bankname: res.data, loading: false })
            if (res.data.length > 0) {
             this.setState({ name_rob: res.data[0].name_rob})
            // const date = res.data[0].dateaddbn;
              }
            }) 
          }, 0);
      }

 



  //ปากเปล่าโปสเตอร์
  handleChangetype(event) {    this.setState({typelevel: event.target.value});  }
  //ปากเปล่าโปสเตอร์สาขา
  handleChangemajor(event) {    this.setState({major_precent: event.target.value});  }
  //ผู้นำเสนอ
  handleChangenamepresent(event) {    this.setState({name_present: event.target.value});  }
    //ผู้นำเสนอ
    handleChangenamepresentcer(event) {    this.setState({name_presentcertificate: event.target.value});  }
//ผู้นำเสนอ
  handleChangesend_name(event) {    this.setState({name_article: event.target.value});  }


  handleChange1(event) {    this.setState({send_uploadeword1: event.target.files[0]});  }
  handleChangew2(event) {    this.setState({send_uploadeword2: event.target.files[0]});  }
  handleChangew3(event) {    this.setState({send_uploadeword3: event.target.files[0]});  }
  handleChangew4(event) {    this.setState({send_uploadeword4: event.target.files[0]});  }

  handleChange2(event) {    this.setState({send_uploadepdf1: event.target.files[0]});  }
  handleChangep2(event) {    this.setState({send_uploadepdf2: event.target.files[0]});  }
  handleChangep3(event) {    this.setState({send_uploadepdf3: event.target.files[0]});  }
  handleChangep4(event) {    this.setState({send_uploadepdf4: event.target.files[0]});  }


  handleChangeURLdrive(event) {    this.setState({URLdrive: event.target.value});  }
 // handleChange4(event) {    this.setState({send_uploadepdf12: event.target.files[0]});  }


 handleSubmit= (e) => {
  e.preventDefault();
    // alert('A name was submitted: ' + this.state.value);
    this.setState(  {loading: true});
   setTimeout(() => {

            const date = new Date();
            const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
            const dates = day+"-"+month+"-"+year ;

              const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
              datafrm.append("id_emp", this.props.iduser);
              datafrm.append("nameuser", this.state.nameuser);
              datafrm.append("send_uploadeword1", this.state.send_uploadeword1);
              datafrm.append("send_uploadeword2", this.state.send_uploadeword2);
              datafrm.append("send_uploadeword3", this.state.send_uploadeword3);
              datafrm.append("send_uploadeword4", this.state.send_uploadeword4);
              datafrm.append("send_uploadepdf1", this.state.send_uploadepdf1);
              datafrm.append("send_uploadepdf2", this.state.send_uploadepdf2);
              datafrm.append("send_uploadepdf3", this.state.send_uploadepdf3);
              datafrm.append("send_uploadepdf4", this.state.send_uploadepdf4);
              datafrm.append("dateadd", dates);
              datafrm.append("status", '1');
              datafrm.append("typelevel", this.state.typelevel);
              datafrm.append("name_rob", this.state.name_rob);


         api.post("registercon/InsertArticlespsf",datafrm,{
            headers: {
                'content-type': 'multipart/form-data'
            }
          })
          .then(res => {
            console.warn(res);
            console.log("response: ", res)
            if (res.data.length !== 0) {
              // this.showitem = true;
              console.log(res)
              console.log(res.data.length) 
            }else{
            // window.location.href = '/'
            }


              if (res.data = '200') {

                                api.get('registercon/selectArticlespfwhereid/'+this.props.iduser)
                                .then(res => {
                               
                                    if (res.data.length > 0) {
                                            const id_articlepsf =  res.data[0].id_articlepsf 
                                            const id_emp =  res.data[0].id_emp 
                                            const nameuser =  res.data[0].nameuser 
                                            const send_uploadeword	 =  res.data[0].send_uploadeword	
                                            const send_uploadeword2	 =  res.data[0].send_uploadeword2	
                                            const send_uploadeword3	 =  res.data[0].send_uploadeword3	
                                            const send_uploadeword4	 =  res.data[0].send_uploadeword4	
                                            const send_uploadepdf		 =  res.data[0].send_uploadepdf		
                                            const send_uploadepdf2		 =  res.data[0].send_uploadepdf2	
                                            const send_uploadepdf3		 =  res.data[0].send_uploadepdf3	
                                            const send_uploadepdf4		 =  res.data[0].send_uploadepdf4	
                                            setTimeout(() => {

                                              const date = new Date();
                                              const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
                                              const dates = day+"-"+month+"-"+year ;
                                              
                                                const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
                                                datafrm.append("id_articlepsf", id_articlepsf);
                                                datafrm.append("id_empbn", id_emp);
                                                datafrm.append("nameuserbn", nameuser);
                                                datafrm.append("send_uploadewordbn",  send_uploadeword);
                                                datafrm.append("send_uploadewordbn2",  send_uploadeword2);
                                                datafrm.append("send_uploadewordbn3",  send_uploadeword3);
                                                datafrm.append("send_uploadewordbn4",  send_uploadeword4);
                                                datafrm.append("send_uploadepdfbn",  send_uploadepdf);
                                                datafrm.append("send_uploadepdfbn2",  send_uploadepdf2);
                                                datafrm.append("send_uploadepdfbn3",  send_uploadepdf3);
                                                datafrm.append("send_uploadepdfbn4",  send_uploadepdf4);
                                                datafrm.append("dateaddbn", dates);
                                                datafrm.append("statusbn",  '1');
                                            
                                              api.post("registercon/InsertArticleinbn",datafrm,{
                                              headers: {
                                                  'content-type': 'multipart/form-data'
                                              }
                                            })
                                          
                                            .then(res => {
                                              console.warn(res);
                                              console.log("response: ", res)
                                              if (res.data.length !== 0) {
                                                // this.showitem = true;
                                                console.log(res)
                                                console.log(res.data.length) 
                                              }else{
                                              // window.location.href = '/'
                                              }
                                          
                                          
                                              if (res.data = '200') {
                                              // message.success("อัพโหลไฟล์สำเร็จ")
                                              //  this.setState({ id_send: ""})
                                              // window.location.href = '/adminfaculty'
                                              this.setState(  {loading: false});

                                            //  this.linenotify();

                                              Swal.fire({
                                                title: 'ลงทะเบียนสำเร็จ',
                                                text: "Successfully registered",
                                                icon: 'success',
                                                showCancelButton: false,
                                                confirmButtonColor: '#3085d6',
                                                cancelButtonColor: '#d33',
                                                confirmButtonText: 'ตกลง'
                                              }).then((result) => {
                                                if (result.isConfirmed) {
                                                //  window.location.href = 'https://scitech.kpru.ac.th/csrm2025/system/Homeuser'
                                                  // Swal.fire(
                                                  //   'Deleted!',
                                                  //   'Your file has been deleted.',
                                                  //   'success'
                                                  // )
                                                 this.props.getatpsf();
                                                  this.toggle()
                                                }
                                              })
                                              
                                              }else{
                                                message.error("อัพโหลไฟล์ไม่สำเร็จ!")
                                              }
                                          
                                            })
                                          
                                          
                                          
                                          }, 2000);
                                    } else {
                                      
                                    }

                                }) 
            
                    // Swal.fire({
                    //   title: 'เพิ่มผลงานสำเร็จ',
                    //   text: "Add success articles",
                    //   icon: 'success',
                    //   showCancelButton: false,
                    //   confirmButtonColor: '#3085d6',
                    //   cancelButtonColor: '#d33',
                    //   confirmButtonText: 'ตกลง'
                    // }).then((result) => {
                    //   if (result.isConfirmed) {
                      
                    //     this.props.list();
                    //     this.toggle()
                    //   }
                    // })
              
              }else{
                message.error("อัพโหลไฟล์ไม่สำเร็จ!")
              }

          })



   }, 2000);

//window.location.href = '/adminfaculty'
//this.props.updateat();
//this.getExpert()

  }



  

    render() {
       const text = <span> <img src={fx} className="rounded mx-auto "  alt="aligment" />      </span>;
      // const buttonWidth = 60;


    //  const text = <span>Title</span>;
// const content = (
//   <div>
//    <img src={fx} className="rounded mx-auto "  alt="aligment" /> 
//   </div>
// );




          console.log(this.state.send_type)
          console.log(this.state.major_precent)
          console.log(this.state.name_present)
          console.log(this.state.send_name)
          console.log(this.state.send_uploadeword1)
          console.log(this.state.send_uploadepdf1)
          console.log(this.state.radio)
           console.log(this.state.nameuser)
            console.log(this.state.iduser)

          const items = this.state.articletype.map((articletype, i) => (
            <option  value={articletype.presentype_id	} >{articletype.presentype_name}</option>
          ));


        return (
          
            <MDBContainer className='text-left'>
           <div className='text-center'><MDBBtn color="deep-purple" onClick={this.toggle}><MDBIcon icon="plus-square" />  เพิ่มผลงาน</MDBBtn></div> 

            <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="fluid">
              <MDBModalHeader toggle={this.toggle}>เพิ่มผลงาน KPRU PSF</MDBModalHeader>
         
              <form 
                   onSubmit={this.handleSubmit}
                 >

              <MDBModalBody>
                 {/* <img src={ban} className="rounded mx-auto " alt="aligment" />    */}
                <div>
                {/* <br/> */}
                            {/* <div className="mb-2">
                            <label><strong>กลุ่มเนื้อหาการนำเสนอ</strong></label> <label className="red-text">*</label>
                            <select className="browser-default custom-select" onChange={this.handleChangetype} required>
                              <option value="" >---เลือกกลุ่มเนื้อหาการนำเสนอ---</option>
                              {items}
                                     
                            </select>
                            </div> */}

                            <div className="mb-2">
                           <label><strong>ชื่อผู้ขอรับการประเมิน  </strong></label> <label className="red-text">*</label>
                           <input className="form-control" onChange={this.handleChangenamepresent} name="name"
                                    value={this.state.nameuser} placeholder="กรุณาระบุผู้นำเสนอ" disabled />
                            </div>

                           {/* <div className="mb-2">
                           <label><strong>รายชื่อผู้เขียนบทความทั้งหมด (จะแสดงในเกียรติบัตร ตัวอย่าง : ชื่อที่1 ชื่อที่2 และชื่อที่3) </strong></label> <label className="red-text">*</label>
                           <input className="form-control" onChange={this.handleChangenamepresentcer} name="name_presentcertificate"
                                    value={this.state.name_presentcertificate} placeholder="รายชื่อเขียนบทความทั้งหมด" required />
                           </div> */}
                  
{/* 
                           <div className="mb-2">
                           <label><strong>หัวข้องานวิจัย/โครงงาน (จะแสดงในเกียรติบัตร รองรับ LATEX )</strong></label> <label className="red-text">*</label>     <Tooltip placement="topLeft" title={text} style={{width: 700 }}>
                            <Button>ตัวอย่าง สมการ</Button>
                          </Tooltip>
                           <input className="form-control" onChange={this.handleChangesend_name} name="name"
                                    value={this.state.send_name} placeholder="กรุณาระบุหัวข้องานวิจัย" required />
                           </div>
                           {this.state.name_article !== ''?<>
                             <MDBBtn color="primary" size='sm' onClick={this.viwecertificase} >แสดงตัวอย่างเกียรติบัตร</MDBBtn>
                           </>:<></>} */}

                            <div className="mb-2">
                            <label><strong>ระดับที่ขอรับการประเมิน</strong></label> <label className="red-text">*</label>
                            <select className="browser-default custom-select" onChange={this.handleChangetype} required>
                              <option value="" >---เลือกระดับที่ขอรับการประเมิน---</option>
                              <option value="1" >ระดับที่1 อาจารย์ที่มีคุณภาพ </option>
                              <option value="2" >ระดับที่ 2 อาจารย์ที่เกื้อกูลเพื่อนร่วมวิชาชีพให้มีคุณภาพ </option>
                              <option value="3" >ระดับที่ 3 อาจารย์ที่สร้างเพื่อนร่วมวิชาชีพที่มีคุณภาพในมหาวิทยาลัย </option>
                              <option value="4" >ระดับที่ 4 อาจารย์ที่เป็นผู้นำในการพัฒนาวิชาชีพในระดับชาติหรือระดับนานาชาติ</option>
                             
                                     
                            </select>
                            </div>
                          <MDBRow  className='mt-1'>
                  
                          <MDBCol md="3">
                          <div className="mb-2">
                            <label><strong className='blue-text'>1.อัปโหลดไฟล์ผลงาน PSF01 <MDBIcon icon="file-word" /> .docx</strong></label><label className="red-text">*</label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange1}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/msword,*,.doc, .docx"
                                        
                                    />
                            </div>
                          </MDBCol>
                          <MDBCol md="3">
                            <div className="mb-2">
                            <label><strong className='blue-text'>2.อัปโหลดไฟล์ผลงาน PSF02 <MDBIcon icon="file-word" /> .docx</strong></label><label className="red-text">*</label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChangew2}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/msword,*,.doc, .docx"
                                        
                                    />
                            </div>
                          </MDBCol>
                          <MDBCol md="3">
                            <div className="mb-2">
                            <label><strong className='blue-text'>3.อัปโหลดไฟล์ผลงาน PSF03 <MDBIcon icon="file-word" /> .docx</strong></label><label className="red-text">*</label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChangew3}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/msword,*,.doc, .docx"
                                        
                                    />
                            </div>
                          </MDBCol>
                          <MDBCol md="3">
                            <div className="mb-2">
                            <label><strong className='blue-text'>4.อัปโหลดไฟล์ผลงาน PSF04 <MDBIcon icon="file-word" /> .docx</strong></label><label className="red-text">*</label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChangew4}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/msword,*,.doc, .docx"
                                        
                                    />
                            </div>
                          </MDBCol>
                          </MDBRow>
  
                   <MDBRow  className='mt-1'>
                  
                          <MDBCol md="3">
                           <div className="mb-2">
                            <label><strong className='red-text'>5.อัปโหลดไฟล์ผลงาน PSF01 <MDBIcon icon="file-pdf" /> .pdf</strong></label> <label className="red-text">*</label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange2}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/pdf,*"
                                        required
                                    />
                            </div>
                          </MDBCol>
                          <MDBCol md="3">
                           <div className="mb-2">
                            <label><strong className='red-text'>6.อัปโหลดไฟล์ผลงาน PSF02 <MDBIcon icon="file-pdf" /> .pdf</strong></label> <label className="red-text">*</label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChangep2}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/pdf,*"
                                        required
                                    />
                            </div>
                          </MDBCol>
                          <MDBCol md="3">
                           <div className="mb-2">
                            <label><strong className='red-text'>7.อัปโหลดไฟล์ผลงาน PSF03 <MDBIcon icon="file-pdf" /> .pdf</strong></label> <label className="red-text">*</label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChangep3}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/pdf,*"
                                        required
                                    />
                            </div>
                          </MDBCol>
                          <MDBCol md="3">
                           <div className="mb-2">
                            <label><strong className='red-text'>8.อัปโหลดไฟล์ผลงาน PSF04 <MDBIcon icon="file-pdf" /> .pdf</strong></label> <label className="red-text">*</label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChangep4}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/pdf,*"
                                        required
                                    />
                            </div>
                          </MDBCol>

                          </MDBRow>
                          
                           {/* <div className="mb-2">
                           <label><strong>URL drive online เช่น Google Drive ประกอบไฟล์ทั้งหมดที่เป็น LATEX และรูปภาพ (ตั้งค่าแชร์ drive เป็นสาธารณะ) </strong></label> <label className="red-text">*</label>
                           <input className="form-control" onChange={this.handleChangeURLdrive} name="URLdrive"
                                    value={this.state.URLdrive} placeholder="กรุณาระบุ URL drive online" required />
                            </div> */}

                            <div className="mb-2">
          
                                  {/* <MDBInput
                                      gap
                                      onClick={this.onClickradio(1)}
                                      checked={this.state.radio === 1 ? true : false}
                                      label="ท่านยืนยันว่าบทความนี้ไม่ได้มีการตีพิมพ์เผยแพร่ที่ไหนมาก่อน "
                                      type="radio"
                                      id="radio1"
                                      containerClass="mr-5"
                                    /> */}
                                    
                                    {/* <Radio.Group onChange={this.onChange} value={this.state.radio} required>
                                      <Radio value={1}>ยินดีเผยแพร่บทความลงในรายงานสืบเนื่องฯ หรือวารสารที่เข้าร่วมงานประชุม</Radio>
                                      <Radio value={2}>ยินดีเผยแพร่บทความเฉพาะวารสารที่เข้าร่วมงานประชุม</Radio>
                                      <Radio value={3}>ไม่ประสงค์เผยแพร่บทความในทุกช่องทาง</Radio>
                                    </Radio.Group> */}
         
                            </div>

                            {/* <div className="mb-2">
                            <label><strong>อัพโหลดไฟล์รับรองบทความ <MDBIcon icon="file-word" /> .docx</strong></label>
                              
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange3}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/msword,*,.doc, .docx"
                                    />
                            </div>

                            <div className="mb-2">
                            <label><strong>อัพโหลดไฟล์รับรองบทความ <MDBIcon icon="file-pdf" /> .pdf</strong></label>
                              
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange4}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/pdf,*"
                                    />
                            </div> */}



              </div>
            
               {/* <MDBBtn color="primary" type='submit' >บันทึก</MDBBtn> */}
               {/* <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn> */}
           
                
              </MDBModalBody>
              <MDBModalFooter>
              {this.state.loading === true?<>
              <Button type="primary" loading>
          Loading
        </Button>
             </>:<>
             <MDBBtn color="primary" type='submit' >บันทึก</MDBBtn>
             </>}  
                
                
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
               
              </MDBModalFooter>
             
   </form>




            </MDBModal>
          </MDBContainer>
          
        )
    }
}
